export default [
    {
        path: '/quotations',
        component: require('./../../functional/Index').default,
        meta: {
            breadcrumb: 'Quotations'
        },
        children: [
            {
                path: '',
                name: 'Quotations',
                meta: {
                    menuTitle: 'Quotations',
                },
                component: require('./../../views/Quotations/Index').default
            },
            {
                path: '/quotations/view/:quotationId',
                component: require('./../../functional/Index').default,
                meta: {
                    breadcrumb: 'View Quotation'
                },
                children: [
                    {
                        path: '',
                        name: 'View Quotation',
                        component: require('./../../views/Quotations/View').default
                    },
                ]
            }
        ]
    }
]
